var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whats-app-contact-wrapper"},[_c('a',{staticClass:"contact-us-icon sg-contact-us-icon",attrs:{"target":"_blank","href":"https://api.whatsapp.com/send?phone=6591055348"}})])
}]

export { render, staticRenderFns }